import { Button } from "primereact/button"
import { DocumentosGeraveis, PlanoType } from "../../db/Orm"
import { RefObject, useState } from "react"
import API from "../../api/API"
import { Toast } from "primereact/toast"
import { PiFilePlus } from "react-icons/pi"

type GerarDocumentoProps = {
    antecipacao: PlanoType
    documento: DocumentosGeraveis
    carregarPlanos: ()=>Promise<void>|(()=>void)
    toastRef?: RefObject<Toast>
}
const botaoLabels: Record<DocumentosGeraveis, string> = {
    requerimento: 'Gerar Requerimento',
    termo: 'Gerar Termo',
    controles_doc: 'Gerar Plano de Trabalho'
}
export const GeracaoDocumento = (props: GerarDocumentoProps)=>{
    const [gerando, setGerando] = useState<boolean>(false)
    const gerarDocumento = async()=>{
        const antecipacaoId = props.antecipacao.id
        if (antecipacaoId === null) {
            console.error('ID da antecipiação ausente!')
            return
        }
        setGerando(true)
        const resp = await API.gerarDocumentoPlano(antecipacaoId, props.documento)
        if (resp instanceof Error){
            console.error('Erro ao gerar documento', resp)
            props.toastRef?.current?.show({ severity: 'error', summary: 'Erro', detail: 'Erro ao gerar documento' })
        } else {
            props.toastRef?.current?.show({ severity: 'success', summary: 'Sucesso', detail: 'Documento gerado com sucesso' })
            await props.carregarPlanos()
        }
        setGerando(false)
    }
    return <>
        <h3>Este documento ainda não foi gerado pelo sistema</h3>
        <p>Clique no botão abaixo para gerar o documento.</p>
        <p>
            Após gerar o documento, você poderá visualizá-lo e enviá-lo para assinatura.
            <br/>
            O documento gerado será armazenado no sistema e não poderá ser alterado.
        </p>
        <div className="align-center">
            <Button icon={<PiFilePlus style={{ marginRight: '0.5em', transform:'scale(1.5)' }} />} label={botaoLabels[props.documento]}
            onClick={gerarDocumento} disabled={gerando} loading={gerando} />
        </div>
    </>
}